const getBerlinOffset = (date: Date): number => {
  const berlin = new Date(
    date.toLocaleString('en-US', { timeZone: 'Europe/Berlin' })
  );
  const utc = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  return utc.getTime() - berlin.getTime();
};

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length !== 2) return null;
  return parts[1].split(';')[0];
};

export const setCookie = (
  name: string,
  value: string | number,
  days: number
): void => {
  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + (days + 1));

  const berlinDate = new Date(targetDate.toLocaleDateString('en-CA'));
  berlinDate.setHours(8, 0, 0, 0);

  const berlinOffset = getBerlinOffset(berlinDate);
  const utcExpires = new Date(berlinDate.getTime() - berlinOffset);

  document.cookie = `${name}=${value};expires=${utcExpires.toUTCString()};path=/`;
};
